import { TeamLogin } from '@/pages/teams/components/TeamLogin'

export function TeamLoginPage() {
  return <TeamLogin />
}
